export function formatPhoneNumber(phoneNumberString: string) {
	let newPhone = phoneNumberString;
	if (phoneNumberString && phoneNumberString.length !== 10) {
		newPhone = `${phoneNumberString}`;
	}
	const cleaned = ('' + newPhone).replace(/\D/g, '');
	const phoneRegex = /^(\d{3})(\d{3})(\d{4})$/; // Create the RegExp object
	const match = phoneRegex.exec(cleaned); // Use RegExp.exec()

	if (match) {
		return '(' + match[1] + ') ' + match[2] + '-' + match[3];
	}
	return undefined;
}
